/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  ButtonProps,
  CircularProgress,
  Button as MuiButton,
} from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

  type Props = {
    children: ReactNode;
    isLoading?: boolean
  } & ButtonProps;

const Button = ({ isLoading = false, children, ...btnProps }: Props) => {
  const { t } = useTranslation('common');
  return (
    <MuiButton {...btnProps}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {children}
        {isLoading && <CircularProgress size={24} disableShrink thickness={3} sx={{ color: 'pink' }} aria-label={t('ACCESSIBILITY.LOADING')} />}
      </Box>
    </MuiButton>
  );
};

export default Button;
